import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined';
import { Button, Table, Tooltip } from 'antd';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FilterValue, SorterResult } from 'antd/lib/table/interface';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Link } from 'react-router-dom';
import collegeApi from '../../../apis/CollegeApi';
import LayoutComponent from '../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../context/CustomContext';
import { Page } from '../../../model/Elements';
import { College } from '../../../model/Entities';
import notificationService from '../../../services/NotificationService';
import tableService from '../../../services/TableService';
import styles from './CollegesPage.module.scss';

class CollegesPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });
            const collegesPage = await collegeApi.list(tableService.pageSize, 1);
            this.setState({ collegesPage });
        } catch (error) {
        } finally {
            this.setState({ loading: false });
        }
    };

    list = async (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<College> | SorterResult<College>[],
    ) => {
        try {
            this.setState({ loading: true });
            const page = pagination.current!;
            const pageSize = pagination.pageSize!;
            let sortField, sortOrder;
            if (Array.isArray(sorter)) {
            } else {
                sortField = sorter.field as string;
                sortOrder = sorter.order as string;
            }
            const collegesPage = await collegeApi.list(pageSize, page, sortField, sortOrder);
            this.setState({ collegesPage });
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
        } finally {
            this.setState({ loading: false });
        }
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        return (
            <>
                {this.renderToolbar()}
                <div className={styles.table}>{this.renderTable()}</div>
            </>
        );
    };

    renderToolbar = (): React.ReactElement | undefined => {
        return (
            <div className={styles.toolbar}>
                <h1>
                    <FormattedMessage id="colleges.title" />
                </h1>
                <Link to="/admin/colleges/new">
                    <Tooltip title={<FormattedMessage id="colleges.tooltip" />}>
                        <Button type="primary" size="large" className={styles.add} icon={<PlusOutlined />}>
                            <FormattedMessage id="colleges.add" />
                        </Button>
                    </Tooltip>
                </Link>
            </div>
        );
    };

    renderTable = (): React.ReactElement | undefined => {
        const { collegesPage, loading } = this.state;
        const items = collegesPage ? collegesPage.items : [];
        const columns: ColumnsType<College> = [
            {
                title: <FormattedMessage id="colleges.school" />,
                dataIndex: 'school',
                key: 'school',
                sorter: true,
                render: (value: string, college: College) => <Link to={`/admin/colleges/${college.id}`}>{value}</Link>,
            },
            {
                title: <FormattedMessage id="colleges.division" />,
                dataIndex: 'division',
                key: 'division',
                sorter: true,
                render: (value: string, college: College) => <Link to={`/admin/colleges/${college.id}`}>{value}</Link>,
            },
            {
                title: <FormattedMessage id="colleges.athleticWebsite" />,
                dataIndex: 'athleticWebsite',
                key: 'athleticWebsite',
                render: (value: string, college: College) => (
                    <Link to={{ pathname: value }} target="_blank">
                        <FormattedMessage id="colleges.athleticWebsite.url" />
                    </Link>
                ),
            },
            {
                title: <FormattedMessage id="colleges.staffDirectory" />,
                dataIndex: 'staffDirectory',
                key: 'staffDirectory',
                render: (value: string, college: College) => (
                    <Link to={{ pathname: value }} target="_blank">
                        <FormattedMessage id="colleges.staffDirectory.url" />
                    </Link>
                ),
            },
            {
                title: <FormattedMessage id="colleges.admissionLink" />,
                dataIndex: 'admissionLink',
                key: 'admissionLink',
                render: (value: string, college: College) => (
                    <Link to={{ pathname: value }} target="_blank">
                        <FormattedMessage id="colleges.admissionLink.url" />
                    </Link>
                ),
            },
        ];

        return (
            <Table
                dataSource={items}
                columns={columns}
                pagination={tableService.createPagination(collegesPage)}
                rowKey="id"
                onChange={this.list}
                sortDirections={['ascend', 'descend']}
                showSorterTooltip={false}
                loading={loading}
            />
        );
    };

    render() {
        return <LayoutComponent page="admin-colleges" content={this.renderContent} />;
    }
}
export default injectIntl(CollegesPage);

interface Props extends WrappedComponentProps {}

interface State {
    collegesPage?: Page<College>;
    loading?: boolean;
}
